import React, { Component } from "react";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import "./Header.css";

library.add(faTimes);
library.add(faChevronLeft);

class Header extends Component {
  
  GoBack = () => {
    window.history.back();
  }
  render(){
  return (
    <div className="header">
      <div className=""></div>
      {this.props.page !== "main" ? 
      (<div className="back" onClick={this.GoBack}><FontAwesomeIcon icon="chevron-left" /></div>)
      :null}
      <a className="close" href="zepeto://WEBVIEW/CLOSE"><FontAwesomeIcon icon="times" /></a>
      <div className="header-title"> 닮은꼴 대잔치 </div>
    </div>
  );
  }
}
export default Header;